import axios from "axios";
import { PublicClientApplication, SilentRequest } from "@azure/msal-browser";
import { setReturnUrl } from "../../services/localStorageService";

export const configureAxios = (msalInstance: PublicClientApplication) => {
  axios.defaults.baseURL = window.ENVIRONMENT.apiEndpoint
  axios.interceptors.request.use(async (config) => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) return config;

    const request: SilentRequest = {
      scopes: window.ENVIRONMENT.azureAdCredentials.scopes,
      account: accounts[0],
    };

    try {
      const response = await msalInstance.acquireTokenSilent(request);
      config.headers!.Authorization = // eslint-disable-line no-param-reassign
        config.headers!.Authorization || `Bearer ${response.accessToken}`;
      config.headers!["Cache-Control"] = "no-cache, no-store"; // eslint-disable-line no-param-reassign
    } catch (error) {
      console.error("Token fetch error", error);
    }

    return config;
  });
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const currentUrl = window.location.href;
        setReturnUrl(currentUrl);
        window.location.replace(`${window.location.origin}/login`);
      }

      return Promise.reject(error);
    }
  );
};

export default configureAxios;
